import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import i18n from '@/i18n';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const { isAuthenticated, isLoading, clinic } = useAuth();
  const location = useLocation();

  console.log('🌐 PublicRoute:', {
    isAuthenticated,
    isLoading,
    hasClinic: !!clinic,
  });

  // Show loading spinner while checking authentication
  if (isLoading) {
    console.log('⏳ PublicRoute: Still loading...');
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-100 flex flex-col items-center justify-center">
        <Loader2 className="h-12 w-12 animate-spin text-primary-500 mb-4" />
        <p className="text-neutral-600">{i18n.t('common.loading')}</p>
      </div>
    );
  }

  // Redirect to dashboard if already authenticated AND clinic is selected
  // Exception: if user is on /signup with an invitation token, render the page
  // so they can accept the invitation (InvitationSignup handles the redirect)
  if (isAuthenticated && clinic) {
    const params = new URLSearchParams(location.search);
    const hasInvitation =
      params.has('invitation') || params.has('owner_invite');
    if (hasInvitation && location.pathname === '/signup') {
      // Let InvitationSignup handle it — it will accept and redirect to /invitations
      console.log(
        '🎫 PublicRoute: invitation link for logged-in user, rendering signup',
      );
      return <>{children}</>;
    }
    console.log(
      '✅ PublicRoute: Authenticated with clinic, redirecting to dashboard',
    );
    return <Navigate to="/dashboard" replace />;
  }

  // If authenticated but no clinic, let AuthContext handle navigation
  // (it will redirect to clinic selection)
  console.log('📄 PublicRoute: Rendering public page');

  return <>{children}</>;
};
